import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStrikethroughBox20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconStrikethroughBox20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.03 3.03a.75.75 0 0 0-1.06-1.06l-1.314 1.313A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9c0 .417.102.81.283 1.156L1.97 16.97a.75.75 0 1 0 1.06 1.06l1.314-1.313c.345.18.739.283 1.156.283h9a2.5 2.5 0 0 0 2.5-2.5v-9c0-.417-.102-.81-.283-1.156zM14.44 4.5H5.5a1 1 0 0 0-1 1v8.94zm-8.88 11 9.94-9.94v8.94a1 1 0 0 1-1 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStrikethroughBox20);
